import { router } from 'expo-router';
import { useEffect } from 'react';

import { PeopleScreen } from '@/components/domain/members/PeopleScreen';

export default function PeopleNearbyScreen() {
  useEffect(() => {
    // Redirect to the default filter option
    router.replace('/people/nearby/recent');
  }, []);

  return <PeopleScreen listType="nearby" nearbyFilter="recent" />;
}
